import React from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { BlobServiceClient } from "@azure/storage-blob";
import { blobServiceClientConnection } from "../../api/azure";
const containerName = process.env.REACT_APP_AZURE_SAS_CONTAINER_NAME;

async function blobToString(blob) {
  const fileReader = new FileReader();
  return new Promise((resolve, reject) => {
    fileReader.onloadend = (ev) => {
      resolve(ev.target.result);
    };
    fileReader.onerror = reject;
    fileReader.readAsText(blob);
  });
}
const Bloblist = () => {
  const state = useSelector((state) => state.UserReducer);
  const navigate = useNavigate();

  const [file, setFile] = React.useState(null);

  const getFiles = async () => {
    //Get Container
    const containerClient =
      blobServiceClientConnection.getContainerClient(containerName);

    // List the blob(s) in the container.
    for await (const blob of containerClient.listBlobsFlat()) {
      // Get Blob Client from name, to get the URL
      console.log(blob.name);
      const blobClient = containerClient.getBlobClient(blob.name);
      const downloadBlockBlobResponse = await blobClient.download();
      const downloaded = await blobToString(
        await downloadBlockBlobResponse.blobBody,
      );
      console.log("Downloaded blob content", downloaded);
    }
  };

  const uploadFile = async () => {
    //Get Container
    const containerClient =
      blobServiceClientConnection.getContainerClient(containerName);

    const content = "Hello world!";
    const blobName = "newblob" + new Date().getTime() + ".crypt";
    const blockBlobClient = containerClient.getBlockBlobClient(blobName);
    const uploadBlobResponse = await blockBlobClient.upload(
      content,
      content.length,
    );
    console.log(
      `Upload block blob ${blobName} successfully`,
      uploadBlobResponse.requestId,
    );

    // await
  };

  React.useEffect(() => {
    getFiles();
  }, []);

  return (
    <>
      <div className='min-h-full'>
        <main>
          <div className='max-w-7xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='lg:flex lg:items-center justify-between'>
              <div className='flex-1 min-w-0 px-5 lg:px-0'>
                <h2 className='mt-4 ml-1 text-xl font-base leading-7 text-gray-dark sm:text-xl '>
                  Welcome Back, {state?.user?.firstName}
                </h2>
              </div>
            </div>
            <div className='px-4 py-6 sm:px-0 grid justify-items-center'>
              <button
                onClick={(e) => {
                  uploadFile();
                }}
                className='inline-flex mt-5 justify-center py-2 px-4 border-yellow-2 border shadow-sm text-sm font-medium rounded-sm text-yellow-2 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                Create new Blob
              </button>
              <button
                onClick={(e) => {
                  navigate(-1);
                }}
                className='inline-flex mt-5 justify-center py-2 px-4 border-yellow-2 border shadow-sm text-sm font-medium rounded-sm text-yellow-2 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                Back
              </button>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default Bloblist;
